import ApiService from "@/common/api.service"

export const TraineeReportService = {
    getTraineeReports(query) {
        let queryParam = `/trainee-report${query}`;
        return ApiService.get(queryParam);
    },

}